import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map, GeoJSON } from 'react-leaflet';
import MapTooltip from '../map-tooltip';
import styles from './council-map-container.module.scss';
import { setActiveCouncil, setComparedCouncil } from '../../actions/ui';
import 'leaflet/dist/leaflet.css';
import './leaflet.scss';
import bboxArray from 'turf-bbox';
import * as selectors from '../../reducers';
import MapBanner from './map-banner';

const COLOR_BLUE = 'rgb(200, 204, 230)';
const COLOR_HIGHLIGHT = '#6a74c4';

class CouncilMapContainer extends Component {
  constructor() {
    super();
    this.state = {
      hoveredCouncil: null,
      tooltipPosition: { x: 0, y: 0 },
      mapTooltipVisible: false,
    };
    this.highlight = this.highlight.bind(this);
    this.disableHighlight = this.disableHighlight.bind(this);
    this.onEachFeature = this.onEachFeature.bind(this);
    this.selectLayer = this.selectLayer.bind(this);
    this.handleCloseClicked = this.handleCloseClicked.bind(this);
    this.hasRenderedOnce = false;
  }

  highlight() {
    return e => {
      const layer = e.target;
      const councilName = layer.feature.properties['LGA_NAME_2016'];
      const layerBounds = e.originalEvent;

      this.setState({
        hoveredCouncil: councilName,
        tooltipPosition: { x: layerBounds.offsetX, y: layerBounds.offsetY },
        mapTooltipVisible: true,
      });
      layer.setStyle({
        fillColor: COLOR_HIGHLIGHT,
      });
    };
  }

  disableHighlight(e) {
    const layer = e.target;
    this.setState({
      mapTooltipVisible: false,
    });
    layer.setStyle({
      fillColor: COLOR_BLUE,
    });
  }

  selectLayer(e) {
    const { onCouncilSelect } = this.props;
    const layer = e.target;
    const councilId =
      layer && layer.feature && layer.feature.properties
        ? layer.feature.properties['LGA_NAME_2016']
        : null;
    onCouncilSelect(councilId);
  }

  isActiveLayer(feature) {
    const { council } = this.props;
    return feature.properties['LGA_NAME_2016'] === council.id;
  }

  onEachFeature(feature, layer) {
    if (this.isActiveLayer(feature)) {
      layer.setStyle({
        interactive: false,
        fillColor: COLOR_HIGHLIGHT,
      });
    }

    layer.on({
      mouseover: this.highlight(false),
      mouseout: this.disableHighlight,
      click: this.selectLayer,
    });
  }

  getCouncilBounds() {
    const { council, qldCouncilsGeo } = this.props;
    const geoCouncil = qldCouncilsGeo.features.find(councilGeo => {
      return councilGeo.properties['LGA_NAME_2016'] === council.id;
    });
    const boundsArray = bboxArray(geoCouncil.geometry);
    return [[boundsArray[1], boundsArray[0]], [boundsArray[3], boundsArray[2]]];
  }

  handleCloseClicked() {
    const {
      isComparisonCouncil,
      comparisonId,
      setActiveCouncil,
      setComparedCouncil,
    } = this.props;
    if (isComparisonCouncil) {
      // Close the comparison one only
      setComparedCouncil(null);
    } else {
      // Close the current active one, and make the other one active.
      setActiveCouncil(comparisonId);
      // Now close the comparison one.
      setComparedCouncil(null);
    }
  }

  render() {
    const { hoveredCouncil, tooltipPosition, mapTooltipVisible } = this.state;
    const { qldCouncilsGeo, council, comparing, isMobile } = this.props;
    const activeCouncilBounds = this.getCouncilBounds();
    const maxZoom = 10;

    const padding = isMobile ? 200 : 273;
    const paddingOptions = this.hasRenderedOnce
      ? null
      : { paddingTopLeft: [0, padding] };

    return (
      <div
        className={`councilMapWrapper ${styles.councilMapWrapper}`}
        data-comparing={comparing}
      >
        <MapBanner
          council={council}
          comparing={comparing}
          onCloseClicked={this.handleCloseClicked}
        />
        <Map
          key={council.id}
          bounds={activeCouncilBounds}
          boundsOptions={paddingOptions}
          maxZoom={maxZoom}
          scrollWheelZoom={false}
          zoomControl={false}
          doubleClickZoom={false}
          dragging={true}
          onMove={() => {
            this.hasRenderedOnce = true;
          }}
        >
          <GeoJSON
            key={council.id}
            data={qldCouncilsGeo}
            weight={1}
            fillColor={COLOR_BLUE}
            fillOpacity={1}
            color={'#fff'}
            onEachFeature={this.onEachFeature}
          />
        </Map>
        <MapTooltip
          visible={mapTooltipVisible}
          position={tooltipPosition}
          isStatic={true}
        >
          {hoveredCouncil}
        </MapTooltip>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveCouncil,
  setComparedCouncil,
};

const mapStateToProps = state => ({
  qldCouncilsGeo: selectors.getQldCouncilsGeo(state),
  isMobile: selectors.getIsMobile(state),
});

CouncilMapContainer.propTypes = {
  qldCouncilsGeo: PropTypes.object,
  onCouncilSelect: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilMapContainer);



// WEBPACK FOOTER //
// ./src/components/council-map-container/council-map-container.js